import TextArea, { TextAreaProps } from './TextArea'

export default TextArea
export type { TextAreaProps }